import React from 'react';
import classnames from 'classnames';

const Select = ({
    label = '',
    placeholder = null,
    id = 'input',
    name = null,
    validators = [],
    errorMessage = '',
    value = '',
    type = 'text',
    disabled = false,
    required = false,
    autoComplete = undefined,
    className = '',
    inputClassName = null,
    hideLabel = false,
    flex = false,
    collapse = false,
    inline = false,
    showRequired = false,

    multiple = false,

    error = false,
    touched = false,

    children = null,

    onChange = () => {},
    onBlur = () => {},
    onFocus = () => {},
    onKeyUp = () => {}
}) => {
    return (
        <div className={className}>
            {label &&
                <label htmlFor={id} className={classnames({
                    required,
                    hidden: hideLabel
                })}>{label}</label>
            }
            <div className="input-box">
                <select
                    className={classnames({
                        'error': error && touched,
                        'input-collapse': collapse
                    })}
                    value={multiple && !Array.isArray(value) ? [value] : value}
                    name={name || id}
                    id={id}
                    required={required}
                    multiple={multiple}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onChange={onChange}
                    autoComplete={autoComplete}
                    disabled={disabled}
                >
                    {children}
                </select>
                {error && touched &&
                    <div className="errors-list" style={{opacity: 1}}>
                        <span>{error}</span>
                    </div>
                }
                {multiple &&
                    <div className="help-text">
                        <small><code>{window.navigator.platform.includes('Mac') ? 'command' : 'ctrl'} + click</code> to select multiple</small>
                    </div>
                }
            </div>
        </div>
    );
}

export default Select;
